/* eslint-disable no-console */
import * as React from "react";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import logger from "./utils/logger";
import appConfig from "./config";

export interface AxiosInterceptorsProps {
  children: JSX.Element;
}

const AxiosInterceptors = ({ children }: AxiosInterceptorsProps) => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  React.useEffect(() => {
    const reqInterceptor = axios.interceptors.request.use(
      async (config) => {
        if (config?.headers?.Authorization) return config;
        if (!isAuthenticated) return config;

        const newConfig = { ...config };
        const token = await getAccessTokenSilently();

        if (token) {
          newConfig.headers = newConfig.headers ?? {};
          newConfig.headers.Authorization = `Bearer ${token}`;
          newConfig.headers["Ocp-Apim-Subscription-Key"] = appConfig.apimKey;
        }

        return newConfig;
      },
      (error) => {
        logger.error(error);
        return Promise.reject(error);
      },
    );

    const resInterceptor = axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        logger.error(error);
        return Promise.reject(error);
      },
    );

    return () => {
      axios.interceptors.request.eject(reqInterceptor);
      axios.interceptors.response.eject(resInterceptor);
    };
  }, [getAccessTokenSilently, isAuthenticated]);

  return children;
};

export default AxiosInterceptors;
